import { fork, put, takeEvery, takeLatest } from "redux-saga/effects";

import { callApi } from "../../../sagas/helpers/api";
import { setError, setSuccess, startLoading } from "../../../store/appSlice";
import * as CashProvidersApi from "../api/Providers";
import {
  fetchConfigurableProviders,
  fetchProviders,
  fetchSupportedCurrencies,
  providerOperationPaths,
  setConfigurableProviders,
  setList,
  setSupportedCurrencies,
} from "./providers.slice";

function* fetchProvidersSaga({
  payload,
}: {
  payload: {
    id: string;
  };
  type: string;
}) {
  const { listing: operationPath } = providerOperationPaths();

  yield put(startLoading(operationPath));

  try {
    // @ts-ignore noImplicitAny
    const data = yield callApi(CashProvidersApi.getCashManagementProviders);

    yield put(setList(data));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* fetchSupportedCurrenciesSaga(): Generator<any> {
  const operationPath = ["cash", "provider", "currency", "list"];

  yield put(startLoading(operationPath));

  try {
    const data = yield callApi(CashProvidersApi.getSupportedCurrencies);

    yield put(setSupportedCurrencies({ data }));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* fetchConfigurableProvidersSaga({
  type,
}: {
  type: string;
}): Generator<any> {
  const { configurableProviders: operationPath } = providerOperationPaths();

  yield put(startLoading(operationPath));

  try {
    const data = yield callApi(
      CashProvidersApi.getCashManagementConfigurableProviders
    );

    yield put(setConfigurableProviders({ data }));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* watchFetchProviders() {
  yield takeEvery(fetchProviders.type, fetchProvidersSaga);
}

function* watchFetchSupportedCurrencies() {
  yield takeEvery(fetchSupportedCurrencies.type, fetchSupportedCurrenciesSaga);
}

function* watchFetchConfigurableProviders() {
  yield takeLatest(
    fetchConfigurableProviders.type,
    fetchConfigurableProvidersSaga
  );
}

export default function* rootSaga() {
  yield fork(watchFetchProviders);
  yield fork(watchFetchSupportedCurrencies);
  yield fork(watchFetchConfigurableProviders);
}
